import { Injectable, inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/services/toast.service';

@Injectable()
export class CotizacionesCementoUiEffectsService {
  private readonly toast = inject(ToastService);
  private readonly spinner = inject(NgxSpinnerService);

  syncLoading(isLoading: boolean): void {
    if (isLoading) {
      this.spinner.show();
      return;
    }
    this.spinner.hide();
  }

  showLoadError(): void {
    this.toast.showAdminError('No se pudieron cargar las cotizaciones.');
  }

  showCloseSuccess(): void {
    this.toast.showAdminSuccess('Cotización cerrada correctamente.');
  }

  showCloseError(): void {
    this.toast.showAdminError('Error al cerrar la cotización.');
  }
}
